// Aturan lampiran gambar Ticket mengikuti kontrak backend omniv2
// (docs/ticket-attachments-backend.md). Modul ini sengaja tidak mengimpor
// dependency lain agar mudah diuji dan dipakai ulang oleh komponen Ticket.

export const TICKET_ATTACHMENT_MAX_FILES = 3
export const TICKET_ATTACHMENT_MAX_SIZE = 2 * 1024 * 1024
export const TICKET_ATTACHMENT_ACCEPT =
  'image/png,image/jpeg,image/webp,image/gif'
export const TICKET_ATTACHMENT_FORMAT_LABEL = 'PNG, JPG, JPEG, WebP, GIF'
export const TICKET_ATTACHMENT_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif']
export const TICKET_ATTACHMENT_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/gif'
]

export function ticketAttachmentExtension(fileName) {
  const name = String(fileName || '')
    .split('?')[0]
    .split('#')[0]
    .trim()
    .toLowerCase()
  const dotIndex = name.lastIndexOf('.')
  if (dotIndex <= 0 || dotIndex === name.length - 1) return ''
  return name.slice(dotIndex + 1)
}

export function ticketAttachmentMaxSizeLabel(maxSize) {
  const size = Number(maxSize) > 0 ? Number(maxSize) : TICKET_ATTACHMENT_MAX_SIZE
  return Math.round(size / (1024 * 1024)) + ' MB'
}

// Mengembalikan string alasan penolakan, atau string kosong bila file valid.
// MIME diperiksa bila browser menyediakannya; ekstensi tetap wajib didukung
// dan backend memvalidasi isi file lewat magic bytes.
export function ticketAttachmentValidationError(file, options) {
  const settings = options || {}
  const maxSize =
    Number(settings.maxSize) > 0
      ? Number(settings.maxSize)
      : TICKET_ATTACHMENT_MAX_SIZE

  if (!file) return 'File tidak valid.'

  const fileName = String(file.name || '')
  const extension = ticketAttachmentExtension(fileName)
  if (TICKET_ATTACHMENT_EXTENSIONS.indexOf(extension) === -1) {
    return (
      'Format tidak didukung. Gunakan ' +
      TICKET_ATTACHMENT_FORMAT_LABEL +
      '.'
    )
  }

  const mimeType = String(file.type || '').toLowerCase()
  if (mimeType && TICKET_ATTACHMENT_MIME_TYPES.indexOf(mimeType) === -1) {
    return (
      'Tipe file tidak didukung. Gunakan ' +
      TICKET_ATTACHMENT_FORMAT_LABEL +
      '.'
    )
  }

  const size = Number(file.size)
  if (!size || size <= 0) return 'File kosong atau tidak valid.'
  if (size > maxSize) {
    return (
      'Ukuran file melebihi ' +
      ticketAttachmentMaxSizeLabel(maxSize) +
      '. Kompres atau perkecil gambar terlebih dahulu.'
    )
  }

  return ''
}

export function ticketAttachmentCapacityReason(options) {
  const settings = options || {}
  const maxFiles =
    Number(settings.maxFiles) > 0
      ? Number(settings.maxFiles)
      : TICKET_ATTACHMENT_MAX_FILES
  return (
    'Maksimal ' + maxFiles + ' gambar per tiket sudah terpenuhi.'
  )
}

// Memvalidasi sekumpulan file sekaligus. File yang tidak valid tidak
// menggugurkan file lain dalam pemilihan yang sama.
export function filterTicketAttachmentFiles(files, remainingSlots, options) {
  const settings = options || {}
  const maxFiles =
    Number(settings.maxFiles) > 0
      ? Number(settings.maxFiles)
      : TICKET_ATTACHMENT_MAX_FILES
  const limit = Math.max(0, Math.floor(Number(remainingSlots) || 0))
  const list = Array.from(files || [])
  const accepted = []
  const rejected = []

  list.forEach(file => {
    const name = String((file && file.name) || 'Gambar')
    if (accepted.length >= limit) {
      rejected.push({
        file,
        name,
        reason:
          limit <= 0
            ? ticketAttachmentCapacityReason({ maxFiles })
            : 'Melebihi sisa kapasitas. Maksimal ' +
              maxFiles +
              ' gambar per tiket.'
      })
      return
    }

    const reason = ticketAttachmentValidationError(file, settings)
    if (reason) {
      rejected.push({ file, name, reason })
      return
    }

    accepted.push(file)
  })

  return { accepted, rejected }
}

export function formatTicketFileSize(bytes) {
  const value = Number(bytes)
  if (!value || value <= 0) return '-'
  if (value < 1024) return value + ' B'
  if (value < 1024 * 1024) {
    const kb = value / 1024
    return (kb < 10 ? kb.toFixed(1) : Math.round(kb)) + ' KB'
  }
  return (value / (1024 * 1024)).toFixed(2) + ' MB'
}

// Backend mengirim file_name asli; hasil unduhan selalu WebP sehingga nama
// file diganti ekstensinya menjadi .webp.
export function ticketAttachmentDownloadName(fileName) {
  const name = String(fileName || '').trim()
  const extension = ticketAttachmentExtension(name)
  let base = name
  if (extension) {
    const dotIndex = name.length - extension.length - 1
    if (dotIndex > 0) base = name.slice(0, dotIndex)
  }
  base = base
    .replace(/[\\/]+/g, '-')
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/["<>|:*?]+/g, '')
    .trim()
  if (!base) base = 'lampiran-tiket'
  return base + '.webp'
}



// WEBPACK FOOTER //
// ./src/utils/ticketAttachment.js